import { makeAutoObservable } from 'mobx';
import { LeaveTypesI, UnionLocations } from '../types';
import apiConfig from '../api/routes';
import { ProblemsI } from '../components/requestModal/RequestModal';
export interface CountryList  {
  code: string,
  name: UnionLocations,
  typeOfDaysCounting: string
}
export interface ApplicationTemplatesGrid {
  content: string,
  createdAt: string,
  createdBy: string,
  id: number,
  fileName: string | null,
  ref: string | null,
  replacements: string[]
  //isObligatoryForCreate: boolean,
  obligatoryType: string,
  isValid: boolean,
  label: string,
  requestTypeForCountryId: number,
  requestTypeForCountryName: string,
  templateName: string,
  updatedAt: string,
  updatedBy: string,
  warningMessages: ProblemsI[]
}

export interface TypesForTemplates{
  countryCode: string
  countryName: UnionLocations
  requestCategoryId: number
  requestCategoryName: string
  requestCategoryType: string
  requestName: string
  requestTypeId: number
  templateName: string
}
class ApplicationTemplates{
  constructor() {
    makeAutoObservable(this);
  }

  dataGrid: ApplicationTemplatesGrid[] = [];
  countryList: CountryList[] = [];
  typesByCountry: TypesForTemplates[] = [];
  convertedTypes: LeaveTypesI[] = [];
  isTableUpdating = false;
  obligatoryTemplates: ApplicationTemplatesGrid[] = [];
  fetchDataGrid = async (countryName: UnionLocations) => {
    this.isTableUpdating = true;
    this.dataGrid = await apiConfig.applicationTemplates.getAvailableTemplates(countryName);
    this.isTableUpdating = false;
  };

  fetchObligatoryTemplates = async (typeId: number, userId?: number) => {
    this.obligatoryTemplates = await apiConfig.applicationTemplates.obligatoryTemplatesByRequestType(typeId, userId);
  };

  fetchTypesByCountry = async (countryName: UnionLocations) => {
    this.typesByCountry = await apiConfig.applicationTemplates.getLeaveTypesByLocation(countryName);
    this.convertedTypes = this.typesByCountry.map(t => ({type: t.requestCategoryType, infoMessageVisible: true, requestName: t.requestName, requestTypeId: t.requestTypeId, tooltip: '' }));
  };
  validateTemplate = async (file: FormData) => {
    return apiConfig.applicationTemplates.validateTemplate(file);
  };
  downloadLocalFile = async (file: FormData) => {
    return apiConfig.applicationTemplates.downloadLocalFile(file);
  };
  downloadTemplateFile = async (ref: string) => {
    return apiConfig.applicationTemplates.downloadTemplateFile(ref);
  };
  deleteTemplate = async (templateId: number) => {
    return apiConfig.applicationTemplates.deleteTemplate(templateId);
  };
  updateTemplate = async (file: FormData) => {
    return apiConfig.applicationTemplates.updateTemplate(file);
  };
  createTemplate = async (file: FormData) => {
    return  apiConfig.applicationTemplates.createTemplate(file);
  };
  fetchCountryList = async () => {
    this.isTableUpdating = true;
    this.countryList = await apiConfig.applicationTemplates.getCountryList();
    this.isTableUpdating = false;
  };
}

export const ApplicationTemplatesStore = new ApplicationTemplates();